import { IInitialValues } from './types';

export const INITIAL_VALUES: IInitialValues = {
  imageList: [],
  isFetching: false,
  isFetchingFailed: false,
};
